import { render, staticRenderFns } from "./TabMenus.vue?vue&type=template&id=05ba68b8"
import script from "./TabMenus.vue?vue&type=script&lang=js"
export * from "./TabMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05ba68b8')) {
      api.createRecord('05ba68b8', component.options)
    } else {
      api.reload('05ba68b8', component.options)
    }
    module.hot.accept("./TabMenus.vue?vue&type=template&id=05ba68b8", function () {
      api.rerender('05ba68b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Header/TabMenus.vue"
export default component.exports